import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeGb from '@angular/common/locales/en-GB';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Register UK locale
registerLocaleData(localeGb);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
